export const EMPLOYMENT_YEARS = {
  'less than 6 months': 'Less than 6 months',
  '6 months - 1 year': '6 months - 1 year',
  '1-2 years': '1-2 Years',
  '2-3 years': '2-3 Years',
  '3+ years': '3+ Years',
};

export const EMPLOYMENT_STATUS = {
  employed: 'Employed',
  'self-employed': 'Self Employed',
  unemployed: 'Unemployed',
  student: 'Student',
  retired: 'Retired',
  military: 'Military',
};
